/*
 * Healix Product Form contract
 *
 * One source of truth for PDP and mini-PDP variant defaults, matching and
 * availability.  DOM rendering intentionally remains at each surface; this
 * module owns only product data behaviour so a mini-PDP cannot drift from the
 * real PDP's selection rules.
 */
(function () {
  'use strict';

  function optionValue(variant, index) {
    if (!variant) return undefined;
    if (Array.isArray(variant.options)) return variant.options[index];
    return variant['option' + (index + 1)];
  }

  function uniqueValues(variants, index) {
    var seen = {};
    var values = [];
    (variants || []).forEach(function (variant) {
      var value = optionValue(variant, index);
      if (value == null || seen[value]) return;
      seen[value] = true;
      values.push(value);
    });
    return values;
  }

  function normalizeOptions(rawOptions, variants) {
    return (rawOptions || []).map(function (option, index) {
      if (typeof option === 'string') {
        return { name: option, position: index + 1, values: uniqueValues(variants, index) };
      }
      return {
        name: String((option && option.name) || ('Option ' + (index + 1))),
        position: (option && option.position) || index + 1,
        values: Array.isArray(option && option.values) && option.values.length
          ? option.values.slice()
          : uniqueValues(variants, index)
      };
    });
  }

  function isVariantAvailable(variant) {
    return !!variant && variant.available !== false;
  }

  function firstAvailableVariant(variants) {
    return (variants || []).find(isVariantAvailable) || null;
  }

  function initialSelection(config) {
    var options = normalizeOptions(config && config.options, config && config.variants);
    var current = (config && config.currentVariant) || firstAvailableVariant(config && config.variants) || (config && config.variants || [])[0] || null;
    var deferred = (config && config.deferredOptions || []).map(function (name) { return String(name).trim().toLowerCase(); });
    return options.reduce(function (selection, option, index) {
      selection[option.name] = deferred.indexOf(String(option.name).trim().toLowerCase()) >= 0
        ? null
        : (current ? optionValue(current, index) : option.values[0]);
      return selection;
    }, {});
  }

  function variantMatches(variant, options, selection, ignoredIndex) {
    return options.every(function (option, index) {
      if (index === ignoredIndex) return true;
      var selected = selection[option.name];
      return selected == null || String(optionValue(variant, index)) === String(selected);
    });
  }

  function findVariant(variants, rawOptions, selection) {
    var options = normalizeOptions(rawOptions, variants);
    if (options.some(function (option) { return selection[option.name] == null; })) return null;
    return (variants || []).find(function (variant) {
      return variantMatches(variant, options, selection);
    }) || null;
  }

  function isOptionValueAvailable(variants, rawOptions, selection, optionIndex, value) {
    var options = normalizeOptions(rawOptions, variants);
    return (variants || []).some(function (variant) {
      return isVariantAvailable(variant) &&
        String(optionValue(variant, optionIndex)) === String(value) &&
        variantMatches(variant, options, selection, optionIndex);
    });
  }

  window.HealixProductForm = {
    normalizeOptions: normalizeOptions,
    optionValue: optionValue,
    isVariantAvailable: isVariantAvailable,
    firstAvailableVariant: firstAvailableVariant,
    initialSelection: initialSelection,
    findVariant: findVariant,
    isOptionValueAvailable: isOptionValueAvailable
  };
})();
